import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

type Props = {
  open: boolean;
  message: string;
  variant?: "padded" | "flush";
};

const LoadingOverlay: React.FC<Props> = ({ open, message, variant = "padded" }) => {
  if (!open) {
    return null;
  }

  const overlaySx =
    variant === "flush"
      ? {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: "4px",
        }
      : {
          top: "-28px",
          left: "-34px",
          right: "-34px",
          bottom: "-34px",
          borderRadius: "20px",
        };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          backdropFilter: "blur(4px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          zIndex: 9999,
          pointerEvents: "all",
          ...overlaySx,
        }}
      >
        <CircularProgress size={64} />
        <Typography variant="h6" fontWeight={600}>
          {message}
        </Typography>
      </Box>
      {variant === "padded" && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
            pointerEvents: "all",
          }}
        />
      )}
    </>
  );
};

export default LoadingOverlay;
